import React, { useState, useEffect, useRef } from "react";
import { FaBars, FaTimes } from "react-icons/fa";
import "../styles/BottomHeader.css"; 

function BottomHeader() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const menuRef = useRef(null);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
      if (window.innerWidth >= 768) {
        setMenuOpen(false);
      }
    };

    const handleTouchOutside = (event) => {
      if (menuOpen && menuRef.current && !menuRef.current.contains(event.target)) {
        setMenuOpen(false);
      }
    };

    window.addEventListener("resize", handleResize);
    document.addEventListener("touchstart", handleTouchOutside);

    return () => {
      window.removeEventListener("resize", handleResize);
      document.removeEventListener("touchstart", handleTouchOutside);
    };
  }, [menuOpen]);

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  const closeMenu = () => {
    setMenuOpen(false);
  };

  return (
    <div className="BottomHeader">
      <div className="nav-BottomHeader">
        {isMobile && (
          <div className="menu-icon" onClick={toggleMenu}>
            {menuOpen ? <FaTimes /> : <FaBars />}
          </div>
        )}

        <div ref={menuRef} className={`nav-links-BottomHeader ${menuOpen ? "open" : ""} ${isMobile ? "mobile-menu" : ""}`}>
          <a href="/" onClick={closeMenu}>Home</a>
          <a href="/aboutus" onClick={closeMenu}>About Us</a>
          <a href="/training" onClick={closeMenu}>Training</a>
          <a href="/gallery" onClick={closeMenu}>Gallery</a>
        </div>
      </div>
    </div>
  );
}

export default BottomHeader;
